import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ConfirmationAmount extends Component {
  render() {
    return (
      <p
        className="ppvx_text--lg text-center"
        dangerouslySetInnerHTML={{ __html: this.props.message }}
      />
    );
  }
}
export default ConfirmationAmount;

ConfirmationAmount.propTypes = {
  message: PropTypes.string,
};
